/** Tournament start countdown (DD:HH:MM:SS or HH:MM:SS when under 24h). */

export function formatTournamentCountdown(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const d = Math.floor(total / 86400);
  const h = Math.floor((total % 86400) / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  if (d > 0) return `${pad(d)}:${pad(h)}:${pad(m)}:${pad(s)}`;
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}

export function msUntil(iso: string, serverNowIso: string): number {
  return new Date(iso).getTime() - new Date(serverNowIso).getTime();
}
